/*
  Sepet v1.2 (24.10.2026) — Avantaj Vitrini hediye kartlari.
  - "Hediyeyi sepete ekle": secili varyanti 1 adet sepete ekler, cekmeceyi yeniden cizer.
  - Carpi: hediye satirini (1 adet) sepetten cikarir, cekmeceyi yeniden cizer.
  - Secenek cipleri: kartin gorsel/ad/fiyatini ve eklenecek varyanti degistirir.
  Cekmece disinda (sepet sayfasi) sayfa yenilenir; tema da ayni yontemi kullanir.
*/
(function () {
  if (customElements.get("cart-offers")) return;

  const OFFERS_GENERIC_ERROR = "İşlem tamamlanamadı. Lütfen tekrar deneyin.";

  class CartOffers extends HTMLElement {
    constructor() {
      super();
      this.busy = false;
      this.onClick = this.onClick.bind(this);
      this.onOptionChange = this.onOptionChange.bind(this);
    }

    connectedCallback() {
      this.addEventListener("click", this.onClick);
      this.addEventListener("change", this.onOptionChange);
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.onClick);
      this.removeEventListener("change", this.onOptionChange);
    }

    get drawer() {
      return this.closest("cart-drawer");
    }

    get errorElement() {
      return this.querySelector("[data-offer-error]");
    }

    onOptionChange(event) {
      const input = event.target;
      if (!input || !input.matches("[data-offer-option]")) return;
      // Kartlar <cart-drawer-items> icinde: temanin adet guncelleme dinleyicisi
      // (change olayi) bu secimi sepet satiri sanmasin.
      event.stopPropagation();
      if (!input.checked) return;
      const card = input.closest("[data-offer-card]");
      if (!card) return;
      const name = card.querySelector("[data-offer-name]");
      const price = card.querySelector("[data-offer-price]");
      const image = card.querySelector("[data-offer-image]");
      const addButton = card.querySelector("[data-offer-add]");
      if (name && input.dataset.name) name.textContent = input.dataset.name;
      if (price && input.dataset.price) price.textContent = input.dataset.price;
      if (image && input.dataset.image) image.src = input.dataset.image;
      if (addButton) {
        addButton.dataset.variantId = input.value;
        addButton.disabled = input.disabled;
      }
    }

    onClick(event) {
      const addButton = event.target.closest("[data-offer-add]");
      if (addButton && this.contains(addButton)) {
        event.preventDefault();
        this.addGift(addButton);
        return;
      }
      const removeButton = event.target.closest("[data-offer-remove]");
      if (removeButton && this.contains(removeButton)) {
        event.preventDefault();
        this.removeGift(removeButton);
      }
    }

    sectionsToRender() {
      const drawer = this.drawer;
      if (drawer && typeof drawer.getSectionsToRender === "function") {
        return drawer.getSectionsToRender().map((section) => section.id);
      }
      return [];
    }

    addGift(button) {
      if (this.busy || button.disabled) return;
      const variantId = parseInt(button.dataset.variantId, 10);
      if (!variantId) return;
      const body = {
        items: [{ id: variantId, quantity: 1 }],
      };
      const sections = this.sectionsToRender();
      if (sections.length) {
        body.sections = sections.join(",");
        body.sections_url = window.location.pathname;
      }
      this.setBusy(button, true);
      this.request(`${window.routes.cart_add_url}`, body)
        .then((state) => this.afterChange(state))
        .catch((error) => this.showError(error))
        .finally(() => this.setBusy(button, false));
    }

    removeGift(button) {
      if (this.busy) return;
      const lineKey = button.dataset.lineKey;
      if (!lineKey) return;
      const currentQty = parseInt(button.dataset.lineQty, 10) || 1;
      const body = {
        id: lineKey,
        quantity: Math.max(currentQty - 1, 0),
      };
      const sections = this.sectionsToRender();
      if (sections.length) {
        body.sections = sections.join(",");
        body.sections_url = window.location.pathname;
      }
      this.setBusy(button, true);
      this.request(`${window.routes.cart_change_url}`, body)
        .then((state) => this.afterChange(state))
        .catch((error) => this.showError(error))
        .finally(() => this.setBusy(button, false));
    }

    request(url, body) {
      const config = typeof fetchConfig === "function" ? fetchConfig() : {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/javascript" },
      };
      config.body = JSON.stringify(body);
      return fetch(url, config).then((response) =>
        response.json().then((json) => {
          if (!response.ok || json.status) {
            const message = json.description || json.message || OFFERS_GENERIC_ERROR;
            throw new Error(message);
          }
          return json;
        })
      );
    }

    afterChange(state) {
      this.hideError();
      // Not: publish(cartUpdate) bilerek cagrilmiyor; cekmece renderContents ile
      // zaten yeniden ciziliyor (cift istek ve titreme olmasin).
      const drawer = this.drawer;
      if (drawer && state && state.sections && typeof drawer.renderContents === "function") {
        drawer.renderContents(state);
        if (window.AOS && typeof window.AOS.init === "function") window.AOS.init();
        return;
      }
      window.location.reload();
    }

    setBusy(button, busy) {
      this.busy = busy;
      this.classList.toggle("cart-offers--busy", busy);
      if (button) {
        button.classList.toggle("is-loading", busy);
        button.setAttribute("aria-busy", busy ? "true" : "false");
      }
    }

    showError(error) {
      const element = this.errorElement;
      if (!element) return;
      element.textContent = (error && error.message) || OFFERS_GENERIC_ERROR;
      element.hidden = false;
    }

    hideError() {
      const element = this.errorElement;
      if (!element) return;
      element.hidden = true;
      element.textContent = "";
    }
  }

  customElements.define("cart-offers", CartOffers);
})();
